import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f4eaf8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "pagewrapper",
  ref: "pagewrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagewrapper__background_container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "pagewrapper__background" }),
  /*#__PURE__*/_createElementVNode("div", { class: "pagewrapper__background" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Icon, {
      type: "loading",
      class: "pagewrapper__loading"
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templates, (template) => {
      return (_openBlock(), _createElementBlock("div", {
        key: template.path,
        class: "pagecontainer"
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(template.template)))
      ]))
    }), 128))
  ], 512))
}